import React from "react";

const CardComp = ({
  title,
  description,
  projectImage,
  year,
  techStack,
  stats,
  caseStudyLink = "#",
}) => {
  return (
    <div className="
      relative
      h-full
      rounded-3xl
      p-6
      bg-white/5
      border border-white/10
      backdrop-blur-xl
      transition
      hover:scale-[1.02]
      hover:border-[#00F5A0]/40
      hover:shadow-[0_0_40px_rgba(0,245,160,0.15)]
    ">

      {/* IMAGE */}
      <div className="relative h-52 rounded-2xl overflow-hidden mb-6">
        <img
          src={projectImage}
          alt={title}
          className="w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />

        {/* Year badge */}
        <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-semibold bg-black/60 border border-white/20">
          {year}
        </div>
      </div>

      {/* CATEGORY */}
      <span className="text-xs tracking-widest text-[#00F5A0] font-semibold">
        CASE STUDY
      </span>

      {/* TITLE */}
      <h3 className="text-xl font-bold mt-2 mb-2">
        {title}
      </h3>

      {/* DESCRIPTION */}
      <p className="text-sm text-white/70 mb-5 leading-relaxed">
        {description}
      </p>

      {/* TECH STACK */}
      <div className="flex flex-wrap gap-2 mb-6">
        {techStack.map((tech, i) => (
          <span
            key={i}
            className="text-xs px-3 py-1 rounded-full bg-white/5 border border-white/10 text-white/80"
          >
            {tech}
          </span>
        ))}
      </div>

      {/* DIVIDER */}
      <div className="h-px bg-white/10 mb-4" />

      {/* STATS */}
      <div className="space-y-1 mb-6">
        {Object.values(stats).map((stat, i) => (
          <div
            key={i}
            className="text-sm font-semibold text-[#00F5A0]"
          >
            {stat}
          </div>
        ))}
      </div>

      {/* CTA */}
      <a
        href={caseStudyLink}
        className="inline-flex items-center text-sm font-semibold text-[#00CFFF] hover:gap-3 transition-all"
      >
        View Case Study
        <span className="ml-2 text-lg">→</span>
      </a>
    </div>
  );
};

export default CardComp;
